import React from "react"
import { Box, CircularProgress } from '@mui/joy';
import { Icon } from "src/mtska-frontend-app-component/assets";
import { Text } from "../Typography";
import { useTranslation } from 'react-i18next';
import { useFormatter } from "src/mtska-frontend-app-component/utils";

const KPILocal = ({ icon, title, translate, score, compactformat, decimaldigits, format, className = "", style }) => {
    const { formatNumber, formatCurrency } = useFormatter();
    const { t } = useTranslation();

    return (
        <Box className={"mtska-chart mtska-chart-kpi iconic"+(className ? " "+className : "")} style={style}>
            {icon ?
                <Box className="iconwrapper">
                    <Icon icon={icon} family="fal"></Icon>
                </Box>
                :
                <Box sx={{width:'1px'}}></Box>
            }
            <Box className="scorewrapper">
                <Text level="title-sm" className="title">{translate ? t(title) : title}</Text>
                <Text level="title-lg" className="score">
                    {
                        (score == null) && <CircularProgress />
                    }

                    {
                        (score != null && !format) && formatNumber(score)
                    }

                    {
                        (score != null && format === 'currency') && formatCurrency(score, compactformat, decimaldigits)
                    }

                </Text>
            </Box>
        </Box>
    )
}

export default KPILocal;